import { render, staticRenderFns } from "./SimplePersonalizationMenu.vue?vue&type=template&id=5851f49c&scoped=true"
import script from "./SimplePersonalizationMenu.vue?vue&type=script&lang=js"
export * from "./SimplePersonalizationMenu.vue?vue&type=script&lang=js"
import style0 from "./SimplePersonalizationMenu.vue?vue&type=style&index=0&id=5851f49c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5851f49c",
  null
  
)

export default component.exports